module.exports = __webpack_public_path__ + "img/img-coke.581c9d6f.png";